module.exports = __webpack_public_path__ + "img/degustation.16e409bd.jpg";